import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';

function Dashboard() {

  const baseUrl = import.meta.env.REACT_APP_API_BASE_URL;

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <div className="flex min-h-screen">
        <Sidebar />

        <div className="flex-1">
          <Topbar />

          <main className="p-6 md:p-8">
            <div className="rounded-[2rem] border border-slate-200 bg-white/95 p-6 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)] backdrop-blur-sm">
              <div className="min-h-[270px]">
                <p className="text-slate-500">Dashboard content will appear here.</p>
                <span>{baseUrl}</span>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
